export default "__VITE_ASSET__DPTsdp1m__"